import React, { SVGProps } from 'react'
const SvgCalendar = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox={'0 0 24 24'}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="M18 7.241H6a1.5 1.5 0 0 0-1.5 1.5v9.125a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5V8.741a1.5 1.5 0 0 0-1.5-1.5Zm-12 1h12a.5.5 0 0 1 .5.5v9.125a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V8.741a.5.5 0 0 1 .5-.5Z" />
      <path d="M18 7.241H6a1.5 1.5 0 0 0-1.5 1.5v1a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-1a1.5 1.5 0 0 0-1.5-1.5Zm0 1 .09.008a.5.5 0 0 1 .41.492v.5h-13v-.5a.5.5 0 0 1 .5-.5h12Z" />
      <path d="M8.4 5.5a.5.5 0 0 1 .492.41L8.9 6v2.439a.5.5 0 0 1-.992.09l-.008-.09V6a.5.5 0 0 1 .5-.5ZM15.733 5.5a.5.5 0 0 1 .492.41l.008.09v2.439a.5.5 0 0 1-.992.09l-.008-.09V6a.5.5 0 0 1 .5-.5ZM15.467 12.877a.5.5 0 0 1 .09.992l-.09.008h-7a.5.5 0 0 1-.09-.992l.09-.008h7ZM15.467 14.69a.5.5 0 0 1 .09.992l-.09.008h-7a.5.5 0 0 1-.09-.992l.09-.008h7Z" />
    </g>
  </svg>
)
export default SvgCalendar
